export const parseUrl = (url: string) => {
  if (
    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(url) &&
    !url.toLowerCase().startsWith('mailto:')
  ) {
    return `mailto:${url}`;
  }

  if (!/^[a-zA-Z0-9+.-]+:/.test(url)) {
    return `https://${url}`;
  }

  return url;
};
